import ColorStyles from '@Styles/colors.scss';
import React from 'react';
import Button from '@Components/Button/Button';
import Styles from '../../QualityControlBlock.scss';

interface IAddReworkHeaderProps {
    onClick: () => void;
}

export const AddReworkHeader = (props: IAddReworkHeaderProps) => {
    return (
        <div className={Styles.reworkButtonRow}>
            <div className={Styles.reworkTitle}>Rework</div>
            <Button
                variant={'contained'}
                onClick={props.onClick}
                sx={{
                    backgroundColor: ColorStyles.ikeSecondaryDarkBlue,
                    fontWeight: '400',
                    fontSize: '14px',
                    lineHeight: '17px',
                    padding: '.25rem .5rem',
                    textTransform: 'none',
                    '&:hover': {
                        backgroundColor: ColorStyles.ikeSecondaryLightBlue,
                    },
                }}
            >
                Add Rework
            </Button>
        </div>
    );
};
